


import React from 'react';


const UNIT_TYPES = [
  { label: 'Type A - 3 Bedrooms', value: 'A', folder: '01', img: '/images/01.jpg' },
  { label: 'Type B - 3 Bedrooms', value: 'B', folder: '02', img: '/images/02.jpg' },
  { label: 'Type C - 2 Bedrooms', value: 'C', folder: '03', img: '/images/03.jpg' },
  { label: 'Type D - 1 Bedroom', value: 'D', folder: '04', img: '/images/04.jpg' },
  { label: 'Type E - 2 Bedrooms', value: 'E', folder: '05', img: '/images/05.jpg' },
];

const VirtualTour = () => {
  const handleCardClick = (folder) => {
    const url = `/images/Vitrual Tour/${folder}/index.htm`;
    window.open(url, '_blank', 'noopener,noreferrer,width=' + window.screen.availWidth + ',height=' + window.screen.availHeight);
  };

  return (
    <div className="tour-box">
      <h2 className="tour-heading" style={{ color: '#fff', marginBottom: 32 }}>Select a Floor Plan to View Virtual Tour</h2>
      <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap', justifyContent: 'center' }}>
        {UNIT_TYPES.map(type => (
          <div
            key={type.value}
            onClick={() => handleCardClick(type.folder)}
            style={{
              cursor: 'pointer',
              background: '#222',
              borderRadius: 12,
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              width: 200,
              margin: 8,
              padding: 16,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              transition: 'transform 0.2s',
            }}
            onMouseOver={e => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            <img src={type.img} alt={type.label} style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8, marginBottom: 12 }} />
            <div style={{ color: '#fff', fontWeight: 600, fontSize: 18, textAlign: 'center' }}>{type.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VirtualTour;
